import { compose } from 'recompose';
import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';

const userViewedWorkMutation = gql`
  mutation userViewedWork($workId: ID!) {
    sendUserWorkEvent(
      event: {
        name: "user-viewed-work"
        topic: "user-events"
        message: { workId: $workId, source: "explore-app" }
      }
    )
  }
`;

const userViewedWork = graphql(userViewedWorkMutation, {
  props: ({ mutate }) => ({
    userViewedWork: ({ workId }) => {
      mutate({
        variables: { workId },
        ignoreResults: true
      });
    }
  })
});

const withUserEvents = Component => compose(userViewedWork)(Component);

withUserEvents.displayName = 'withUserEvents';

export default withUserEvents;
